import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import withTranslation from 'next-translate/withTranslation'
import config from 'SRC/config/config.json'
import { Name } from '../Name'
import { Surname } from '../Surname'
import { getUserInfo } from '../../../../../selectors'

export class Container extends React.PureComponent {
  isBusinessUser = () => this.props.type !== config.userTypes.freeUserTypeSeo

  getName = () => {
    const { i18n: { t } } = this.props

    const name = config.registrationForm.labels.name[this.props.type]
    return t(`common:${name}`) || ''
  }

  render () {
    const isBusinessUser = this.isBusinessUser()
    return (
      <div className={isBusinessUser ? 'form-ime-prezime' : 'form-ime'}>
        <Name isFullWidth={isBusinessUser} isBusinessUser={isBusinessUser} label={this.getName()} />
        {!isBusinessUser ? <Surname /> : null}
      </div>
    )
  }
}

Container.displayName = 'Title'

const mapStateToProps = state => {
  const result = {}
  const userInfo = getUserInfo(state)
  if (userInfo) {
    if (userInfo.name) {
      result.name = userInfo.name
    }
    if (userInfo.surname) {
      result.surname = userInfo.surname
    }
    if (userInfo.type && userInfo.type.seo) {
      result.type = userInfo.type.seo
    }
  }
  return result
}

Container.propTypes = {
  type: PropTypes.string.isRequired
}

const enhance = compose(
  connect(mapStateToProps),
  withTranslation
)

export default enhance(Container)
